export class ResetUserOrganisationsList {
  public static readonly type =
    '[User/Organisations] ResetUserOrganisationsList';
}
